import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";
import { CircCommonModule } from "../common/common.module";
import { StepDetailsComponent } from "./details/step-details.component";
import { ForwardComponent } from "./forward/forward.component";
import { ForwardByOwnerComponent } from "./forward/owner/forwardByOwner.component";
import { ForwardByOwnerContainerComponent } from "./forward/owner/forwardByOwnerContainer.component";
import { NewStepComponent } from "./new-step/new-step.component";
import { StepEffects } from "./state/step.effects";
import { stepReducer } from "./state/step.reducer";
import { StepsRoutingModule } from "./steps-routing.module";
import { StepTypeForConfirmationModule } from "./types/forConfirmation/forConfirmation.module";
import { StepTypeForInformationModule } from "./types/forInformation/forInformation.module";
import { StepTypeMailModule } from "./types/mail/mail.module";
import { WorkComponent } from "./work/work.component";

@NgModule({
  declarations: [
    NewStepComponent,
    StepDetailsComponent,
    ForwardComponent,
    ForwardByOwnerComponent,
    ForwardByOwnerContainerComponent,
    WorkComponent
  ],
  imports: [
    CircCommonModule,
    StepsRoutingModule,
    StepTypeForInformationModule,
    StepTypeForConfirmationModule,
    StepTypeMailModule,
    StoreModule.forFeature("steps", stepReducer),
    EffectsModule.forFeature([StepEffects])
  ],
  exports: [
    StepTypeForInformationModule,
    StepTypeForConfirmationModule,
    StepTypeMailModule
  ]
})
export class StepsModule {}
